// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "", "",{"version":3,"sources":[],"names":[],"mappings":"","file":"variables.scss"}]);
// Exports
exports.locals = {
	"menuText": "#323639",
	"menuActiveText": "#006be6",
	"subMenuActiveText": "#006be6",
	"menuBg": "#fff",
	"menuHover": "rgba(0, 107, 230, 0.15)",
	"subMenuBg": "#fff",
	"subMenuHover": "rgba(0, 107, 230, 0.15)",
	"sideBarWidth": "184px"
};
module.exports = exports;
